import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import {
  Col, Container, Row, Badge,
} from 'reactstrap';
import DataTable from '../../../../../shared/components/DataTable';

import {
  fetchContentRecords,
  deleteContentRecord,
} from '../../../../../redux/actions/contentRecordsActions';
import Confirm from '../../../../../shared/components/Confirm';
import LoadingSpinner from '../../../../../shared/components/LoadingSpinner';
import { createErrorMessage, createSuccessMessage } from '../../../../../helpers/notification';
import ModalForm from '../../../../../shared/components/form/Modal';
import ContentRecordForm from './Edit/index';
import {
  dateDDMMYYFormat,
} from '../../../../../helpers/dateFormat';

class ContentRecordContainer extends PureComponent {
  static propTypes = {
    subjectPeriodId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    esFinClases: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    profesoresMateria: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      modal: false,
      canEdit: false,
      items: [],
      filters: { id: 20 },
    };
    this.columns = [
      {
        key: 'id',
        name: '#',
        width: '80px',
        search: true,
        type: 'number',
      },
      {
        key: 'fecha',
        name: 'Fecha',
        search: true,
        type: 'date',
        width: '130px',
        format: row => dateDDMMYYFormat(row.fecha),
      },
      {
        key: 'profesor',
        name: 'Profesor',
        search: true,
        width: '130px',
        format: ({ profesorContenido }) => profesorContenido.label,
      },
      {
        key: 'unidad',
        name: 'Unidad',
        width: '130px',
        search: true,
      },
      {
        key: 'contenidos',
        name: 'Contenido',
        search: true,
        format: ({
          id, contenidos = '', modalidad, tipoClase, tiposContenidos,
        }) => (
          <span style={{
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'row',
            flexWrap: 'wrap',
            columnGap: '1rem',
          }}
          >
            <div style={{ width: '100%' }}>{contenidos.substring(0, 50)}</div>
            <h5>
              <Badge key={`badge-modalidad-${id}`} color="secondary">
                {`${modalidad.label}`}
              </Badge>
            </h5>
            <h5>
              <span style={{ fontSize: '12px' }}>Tipo Clase:</span>
              <Badge key={`badge-tipoClase-${id}`} color="secondary">
                {`${tipoClase.label}`}
              </Badge>
            </h5>
            <h5>
              <span style={{ fontSize: '12px' }}>Tipo Contenido:</span>
              {tiposContenidos.map(tc => (
                <Badge
                  key={`badge-tipoContenido-${id}-${tc.value}`}
                  color="secondary"
                  style={{ marginRight: '0.5em' }}
                >
                  {`${tc.label}`}
                </Badge>
              ))}
            </h5>
          </span>
        ),
      },
      {
        key: 'metodologias',
        name: 'Metodologías',
        search: true,
        format: ({
          id, metodologias,
        }) => (
          <span style={{
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'row',
            flexWrap: 'wrap',
            columnGap: '1rem',
          }}
          >
            {metodologias.map(({ value, label }) => (
              <h5>
                <Badge
                  id={`badge-metodologias-${id}-${value}`}
                  key={`badge-metodologias-${id}-${value}`}
                  color="info"
                  style={{ marginRight: '0.5em' }}
                >
                  {`${label}`}
                </Badge>
              </h5>
            ))}
          </span>
        ),
      },
      { key: 'actions', name: 'Accion', width: '85px' },
    ];
    this.actions = show => [
      {
        key: 'view',
        show: true,
        icon: <span className="fa fa-eye" title="Ver Registro de Contenido" />,
        callback: this.handleView,
      },
      {
        key: 'edit',
        show,
        icon: <span className="fa fa-edit" title="Editar Registro de Contenido" />,
        callback: this.edit,
      },
      {
        key: 'delete',
        show,
        icon: <span className="fa fa-trash" title="Borrar Registro de Contenido" />,
        callback: this.handleDelete,
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.updateStudentsTable(page, pageSize);
  }

  updateStudentsTable = (page, pageSize, filters = {}) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });

    const { subjectPeriodId } = this.props;

    fetchContentRecords({
      subjectPeriodId,
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de Registro de Contenido');
      },
    });
  }

  handleDelete = ({ id, profesorContenido, fecha }) => {
    const name = `#${id} de ${profesorContenido.label}, ${dateDDMMYYFormat(fecha)}`;
    Confirm({
      title: 'Borrar Registro de Contenido',
      question: `¿Estás seguro que deseas eliminar el Registro de Contenido: ${name}?`,
      yesLabel: 'Si, Borrar Registro de Contenido',
      noLabel: 'No, Volver',
      onConfirm: () => {
        deleteContentRecord(id, {
          onSuccess: () => {
            createSuccessMessage('Registro de Contenido borrado exitosamente');
            const { page, pageSize } = this.state;
            this.updateStudentsTable(page, pageSize);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El Registro de Contenido no existe');
            } else {
              createErrorMessage('Error al intentar borrar el Registro de Contenido');
            }
          },
        });
      },
    });
  };

  handleView = ({ id }) => this.handleOpenModal({ id, canEdit: false });

  edit = ({ id }) => this.handleOpenModal({ id, canEdit: true });

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateStudentsTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateStudentsTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateStudentsTable(1, pageSize, {});
  };

  getGridActions = ({ key, show }) => {
    const actions = {
      actions: this.actions(show).filter(a => a.show),
    };

    return actions[key];
  }

  // Abrir/cerrar modal
  toggle = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  // Abrir modal para crear o editar
  handleOpenModal = ({ id = 0, canEdit = false }) => {
    this.setState({
      modal: true,
      canEdit,
      selectedContentRecordId: id,
    });
  }

  // Al confirmar (guardar)
  handleOkModal = () => {
    const { page, pageSize } = this.state;
    this.updateStudentsTable(page, pageSize);
    this.toggle();
  }

  // Al cancelar
  handleCancelModal = () => {
    this.setState({ selectedContentRecordId: 0 });
    this.toggle();
    const { page, pageSize } = this.state;
    this.updateStudentsTable(page, pageSize);
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
      modal,
      canEdit,
      selectedContentRecordId,
    } = this.state;

    const { subjectPeriodId, profesoresMateria, esFinClases } = this.props;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Registro de Contenido</h3>
            {!esFinClases ? (
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => this.handleOpenModal({ id: 0, canEdit: true })}
              >
                <i className="fa fa-plus" /> Agregar nuevo Registro de Contenido
              </button>
            ) : null}

            <ModalForm
              header
              buttonToolbar={false}
              colored={false}
              color="primary"
              title="Registro de Contenido"
              isOpen={modal}
              toggle={this.toggle}
              onOk={this.handleOkModal}
              onCancel={this.handleCancelModal}
              okButtonText="Guardar"
              cancelButtonText="Cancelar"
              size="xl"
            >
              {
                !selectedContentRecordId && selectedContentRecordId !== 0
                  ? <LoadingSpinner />
                  : (
                    <ContentRecordForm
                      id={selectedContentRecordId}
                      subjectPeriodId={subjectPeriodId}
                      profesoresMateria={profesoresMateria}
                      canEdit={canEdit && !esFinClases}
                      onCancel={this.handleCancelModal}
                    />
                  )
              }

            </ModalForm>
          </Col>
        </Row>
        <Row>
          {loading ? <LoadingSpinner />
            : (
              <DataTable
                title="Listado de todos los Registros de Contenido"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                getGridActions={key => this.getGridActions({ key, show: !esFinClases })}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(ContentRecordContainer);
